import surahs from 'data/surahs'
import { getSurahPageHref } from 'helpers/surahAnchor'
import type { IconType } from 'react-icons'
import {
  FaBookOpen,
  FaHeart,
  FaMosque,
  FaShieldAlt,
  FaStickyNote,
  FaUsers,
} from 'react-icons/fa'
import { GiPrayerBeads } from 'react-icons/gi'

export type SearchShortcut = {
  name: string
  href: string
  icon: IconType
}

/** Finds a surah's reader link by its surah number (1-114). */
const getSurahHrefByNumber = (surahNumber: number): string =>
  getSurahPageHref(surahs[surahNumber - 1])

/**
 * The tiles shown before the user types, for the most used parts of the app.
 * Icons match the ones in the site menu (navConfig.ts) where the page is listed there.
 */
export const QUICK_ACCESS_SHORTCUTS: SearchShortcut[] = [
  { name: "Kur'an", href: '/kuran', icon: FaBookOpen },
  { name: 'Dualar', href: '/dualar', icon: FaMosque },
  { name: 'Cevşen', href: '/cevsen', icon: FaShieldAlt },
  { name: 'Zikirmatik', href: '/zikirmatik', icon: GiPrayerBeads },
  { name: 'Ortak Hatim', href: '/ortak-hatim', icon: FaUsers },
  { name: 'Not Defteri', href: '/not-defteri', icon: FaStickyNote },
  { name: 'Sıla-i Rahim', href: '/sila-i-rahim-takibi', icon: FaHeart },
  { name: 'Sizden Gelenler', href: '/sizden-gelen-dualar', icon: FaMosque },
]

/** A short list of often-read content, shown under the quick access tiles. */
export const HIGHLIGHTED_CONTENT: { name: string; href: string }[] = [
  { name: 'Yâsin Suresi', href: getSurahHrefByNumber(36) },
  { name: 'Sabah Duaları', href: '/dualar/sabah-dualari' },
  { name: 'Akşam Duaları', href: '/dualar/aksam-dualari' },
  { name: 'Mülk Suresi', href: getSurahHrefByNumber(67) },
  { name: 'Cevşen-i Şerif', href: '/cevsen' },
  { name: 'Korunma Duası', href: '/dualar/korunma-duasi' },
]

/** Example queries that teach the search syntax; tapping one fills the search field. */
export const EXAMPLE_QUERIES = ['Yâsin', '2:255', 'Kuran 50', 'Cüz 30', 'Sabah 2']
